// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file medical_master/common.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from message com.neulink.pharmacy.MedicalMaster
 */
export class MedicalMaster extends Message<MedicalMaster> {
  /**
   * Unique identifier for the medical master record
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * Trade name of the medical item
   *
   * @generated from field: string trade_name = 2;
   */
  tradeName = "";

  /**
   * Unit of measurement for the medical item
   *
   * @generated from field: int32 unit = 3;
   */
  unit = 0;

  /**
   * Type of unit (e.g., mg, ml)
   *
   * @generated from field: string unit_type = 4;
   */
  unitType = "";

  /**
   * Barcode for the medical item
   *
   * @generated from field: string barcode = 5;
   */
  barcode = "";

  /**
   * Metadata associated with the medical item
   *
   * @generated from field: com.neulink.pharmacy.MedicalMasterMetadata metadata = 6;
   */
  metadata?: MedicalMasterMetadata;

  /**
   * Indicates if the medical item is active
   *
   * @generated from field: bool is_active = 7;
   */
  isActive = false;

  /**
   * Tax profile associated with the medical item
   *
   * @generated from field: com.neulink.pharmacy.TaxProfile tax_profile = 8;
   */
  taxProfile?: TaxProfile;

  constructor(data?: PartialMessage<MedicalMaster>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.MedicalMaster";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "trade_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "unit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "unit_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "barcode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "metadata", kind: "message", T: MedicalMasterMetadata },
    { no: 7, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "tax_profile", kind: "message", T: TaxProfile },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MedicalMaster {
    return new MedicalMaster().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MedicalMaster {
    return new MedicalMaster().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MedicalMaster {
    return new MedicalMaster().fromJsonString(jsonString, options);
  }

  static equals(a: MedicalMaster | PlainMessage<MedicalMaster> | undefined, b: MedicalMaster | PlainMessage<MedicalMaster> | undefined): boolean {
    return proto3.util.equals(MedicalMaster, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.MedicalMasterMetadata
 */
export class MedicalMasterMetadata extends Message<MedicalMasterMetadata> {
  /**
   * Manufacturer of the medical item
   *
   * @generated from field: string manufacturer = 1;
   */
  manufacturer = "";

  /**
   * Owner of the medical item
   *
   * @generated from field: string owner = 2;
   */
  owner = "";

  /**
   * Route of administration for the medical item
   *
   * @generated from field: string route_of_administration = 3;
   */
  routeOfAdministration = "";

  /**
   * Scientific name of the medical item
   *
   * @generated from field: string scientific_name = 4;
   */
  scientificName = "";

  /**
   * Strength of the medical item
   *
   * @generated from field: string strength = 5;
   */
  strength = "";

  /**
   * Source of the medical item
   *
   * @generated from field: string source = 6;
   */
  source = "";

  /**
   * DDC code for the medical item
   *
   * @generated from field: string ddc_code = 7;
   */
  ddcCode = "";

  /**
   * Ingredient of the medical item
   *
   * @generated from field: string ingredient = 8;
   */
  ingredient = "";

  /**
   * Last updated date for DDC information
   *
   * @generated from field: string ddc_last_updated = 9;
   */
  ddcLastUpdated = "";

  constructor(data?: PartialMessage<MedicalMasterMetadata>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.MedicalMasterMetadata";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "manufacturer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "owner", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "route_of_administration", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "scientific_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "strength", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "ddc_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "ingredient", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "ddc_last_updated", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MedicalMasterMetadata {
    return new MedicalMasterMetadata().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MedicalMasterMetadata {
    return new MedicalMasterMetadata().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MedicalMasterMetadata {
    return new MedicalMasterMetadata().fromJsonString(jsonString, options);
  }

  static equals(a: MedicalMasterMetadata | PlainMessage<MedicalMasterMetadata> | undefined, b: MedicalMasterMetadata | PlainMessage<MedicalMasterMetadata> | undefined): boolean {
    return proto3.util.equals(MedicalMasterMetadata, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.PriceHistory
 */
export class PriceHistory extends Message<PriceHistory> {
  /**
   * Unique identifier for the price history record
   *
   * @generated from field: string master_price_history_id = 1;
   */
  masterPriceHistoryId = "";

  /**
   * List of states associated with the price history
   *
   * @generated from field: repeated string associated_states = 2;
   */
  associatedStates: string[] = [];

  /**
   * Price of the medical item
   *
   * @generated from field: float price = 3;
   */
  price = 0;

  /**
   * Date when the price becomes effective
   *
   * @generated from field: google.protobuf.Timestamp effective_date = 4;
   */
  effectiveDate?: Timestamp;

  /**
   * Timestamp when the price history was created
   *
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * Indicates if the price history was accepted by the pharmacy
   *
   * @generated from field: bool accepted_by_pharmacy = 6;
   */
  acceptedByPharmacy = false;

  /**
   * Timestamp when the price history was accepted
   *
   * @generated from field: google.protobuf.Timestamp accepted_at = 7;
   */
  acceptedAt?: Timestamp;

  /**
   * Indicates if this is the current active price for the pharmacy   
   *
   * @generated from field: bool is_current_active_price_for_pharmacy = 8;
   */
  isCurrentActivePriceForPharmacy = false;

  constructor(data?: PartialMessage<PriceHistory>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.PriceHistory";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "master_price_history_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "associated_states", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "price", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "effective_date", kind: "message", T: Timestamp },
    { no: 5, name: "created_at", kind: "message", T: Timestamp },
    { no: 6, name: "accepted_by_pharmacy", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "accepted_at", kind: "message", T: Timestamp },
    { no: 8, name: "is_current_active_price_for_pharmacy", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PriceHistory {
    return new PriceHistory().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PriceHistory {
    return new PriceHistory().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PriceHistory {
    return new PriceHistory().fromJsonString(jsonString, options);
  }

  static equals(a: PriceHistory | PlainMessage<PriceHistory> | undefined, b: PriceHistory | PlainMessage<PriceHistory> | undefined): boolean {
    return proto3.util.equals(PriceHistory, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.PricingPendingAcceptance
 */
export class PricingPendingAcceptance extends Message<PricingPendingAcceptance> {
  /**
   * Unique identifier for the medical master record
   *
   * @generated from field: string medical_master_id = 1;
   */
  medicalMasterId = "";

  /**
   * Trade name of the medical item
   *
   * @generated from field: string trade_name = 2;
   */
  tradeName = "";

  /**
   * Type of unit (e.g., mg, ml)
   *
   * @generated from field: string unit_type = 3;
   */
  unitType = "";

  /**
   * Unit of measurement for the medical item
   *
   * @generated from field: int32 unit = 4;
   */
  unit = 0;

  /**
   * Unique identifier for the price history record
   *
   * @generated from field: string price_history_id = 5;
   */
  priceHistoryId = "";

  /**
   * Price of the medical item
   *
   * @generated from field: float price = 6;
   */
  price = 0;

  /**
   * Date when the price becomes effective
   *
   * @generated from field: google.protobuf.Timestamp effective_date = 7;
   */
  effectiveDate?: Timestamp;

  /**
   * Old price of the medical item
   *
   * @generated from field: float old_price = 8;
   */
  oldPrice = 0;

  constructor(data?: PartialMessage<PricingPendingAcceptance>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.PricingPendingAcceptance";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "medical_master_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "trade_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "unit_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "unit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "price_history_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "price", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 7, name: "effective_date", kind: "message", T: Timestamp },
    { no: 8, name: "old_price", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PricingPendingAcceptance {
    return new PricingPendingAcceptance().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PricingPendingAcceptance {
    return new PricingPendingAcceptance().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PricingPendingAcceptance {
    return new PricingPendingAcceptance().fromJsonString(jsonString, options);
  }

  static equals(a: PricingPendingAcceptance | PlainMessage<PricingPendingAcceptance> | undefined, b: PricingPendingAcceptance | PlainMessage<PricingPendingAcceptance> | undefined): boolean {
    return proto3.util.equals(PricingPendingAcceptance, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.TaxProfile
 */
export class TaxProfile extends Message<TaxProfile> {
  /**
   * List of applicable tax components
   *
   * @generated from field: repeated com.neulink.pharmacy.TaxComponent applicable_taxes = 1;
   */
  applicableTaxes: TaxComponent[] = [];

  /**
   * List of classification codes for the medical item
   *
   * @generated from field: repeated com.neulink.pharmacy.ClassificationCode classification_codes = 2;
   */
  classificationCodes: ClassificationCode[] = [];

  constructor(data?: PartialMessage<TaxProfile>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.TaxProfile";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "applicable_taxes", kind: "message", T: TaxComponent, repeated: true },
    { no: 2, name: "classification_codes", kind: "message", T: ClassificationCode, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TaxProfile {
    return new TaxProfile().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TaxProfile {
    return new TaxProfile().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TaxProfile {
    return new TaxProfile().fromJsonString(jsonString, options);
  }

  static equals(a: TaxProfile | PlainMessage<TaxProfile> | undefined, b: TaxProfile | PlainMessage<TaxProfile> | undefined): boolean {
    return proto3.util.equals(TaxProfile, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.TaxComponent
 */
export class TaxComponent extends Message<TaxComponent> {
  /**
   * Description of the tax component
   *
   * @generated from field: string description = 1;
   */
  description = "";

  /**
   * Tax rate as a percentage
   *
   * @generated from field: float rate_percent = 2;
   */
  ratePercent = 0;

  /**
   * Code of the tax component
   *
   * @generated from field: string component_code = 3;
   */
  componentCode = "";

  constructor(data?: PartialMessage<TaxComponent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.TaxComponent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "rate_percent", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "component_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TaxComponent {
    return new TaxComponent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TaxComponent {
    return new TaxComponent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TaxComponent {
    return new TaxComponent().fromJsonString(jsonString, options);
  }

  static equals(a: TaxComponent | PlainMessage<TaxComponent> | undefined, b: TaxComponent | PlainMessage<TaxComponent> | undefined): boolean {
    return proto3.util.equals(TaxComponent, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.ClassificationCode
 */
export class ClassificationCode extends Message<ClassificationCode> {
  /**
   * Classification code ("HSN", "ATC", etc.)
   *
   * @generated from field: string type = 1;
   */
  type = "";

  /**
   * Description of the classification code
   *
   * @generated from field: string description = 2;
   */
  description = "";

  /**
   * Source of the classification code
   *
   * @generated from field: string source = 3;
   */
  source = "";

  /**
   * Actual classification code
   *
   * @generated from field: string code = 4;
   */
  code = "";

  constructor(data?: PartialMessage<ClassificationCode>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ClassificationCode";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ClassificationCode {
    return new ClassificationCode().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ClassificationCode {
    return new ClassificationCode().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ClassificationCode {
    return new ClassificationCode().fromJsonString(jsonString, options);
  }

  static equals(a: ClassificationCode | PlainMessage<ClassificationCode> | undefined, b: ClassificationCode | PlainMessage<ClassificationCode> | undefined): boolean {
    return proto3.util.equals(ClassificationCode, a, b);
  }
}

